<template>
  <div id="contact">
    <div class="container-fluid padding-top padding-bottom">
      <div
        class="row section-title text-center"
        style="margin-top: 90px !important"
      >
        <div class="col-sm-12 col-sm-offset-2">
          <h3 class="contcat-12">{{ $t("contactSection.contact_us") }}</h3>
          <p>
            {{ $t("contactSection.contact_description") }}
          </p>
        </div>
      </div>
      <div class="row text-center">
        <div class="col-sm-3">
          <div class="contact-info">
            <i class="fa fa-home"></i>
            <h3>{{ $t("contactSection.headquarters") }}</h3>
            <p>{{ $t("contactSection.headquarters_address") }}</p>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="contact-info">
            <i class="fa fa-comment"></i>
            <h3>{{ $t("contactSection.our_mail") }}</h3>

            <a href="mailto:customercare@aboodbus.co.tz"
              >customercare@aboodbus.co.tz</a
            >
          </div>
        </div>
        <div class="col-sm-3">
          <div class="contact-info">
            <i class="fa fa-phone"></i>
            <h3>{{ $t("contactSection.our_phone") }}</h3>
            <a href="tel:+255748771551">+255 748 771 551</a>
          </div>
        </div>

        <div class="col-sm-3">
          <div class="contact-info">
            <i class="fa fa-whatsapp"></i>
            <h3>Abood Ticket</h3>
            <a href="tel:+255793444333">+255 793 444 333</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactSection",
};
</script>

<style scoped>
/* .contcat-12{
    display: inline-block;
    position: relative;
    font-size: 30px;
    font-weight: 700;
    text-transform: uppercase;
    color: #000;
    margin-bottom: 20px;
  } */
</style>
